<template>
  <div id="modal" class="modal save_modal" v-show="modalShown">
    <div v-bind:class="{'modal-main': true, layoutType}" id="save-modal">
      <div :class="'title-area ' + titleAreaAddStyle" v-if="title">
        <h2>{{ title }}</h2>
      </div>
      <div :class="'message-area ' + messageAreaAddStyle">
        <div v-for="(m, index) in messages" :key="index">
          {{ m }}
        </div>
      </div>
      <div>
        <!-- 保存名 -->
        <input type="text" class="name-field" v-model="saveName" maxlength="64" placeholder=""/>
        <label v-if="errors.saveName" class="error_text">{{errors.saveName}}</label>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onCancelLoc" v-if="modalType !== 'message'">{{cancelBtnLabel}}</button>
        <button type="button" class="main_btn" @click="onOkLoc">{{okBtnLabel}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {KEY_CODE} from '../../../constants/App'

export default {
  name: 'Modal',
  props: {
    /** タイトル */
    title: {
      type: String,
      default: ''
    },
    /** メッセージ */
    messages: {
      type: Array,
      default: function () { return [] }
    },
    /** メッセージ表示 or 確認ダイアログ */
    modalType: {
      type: String,
      default: 'message' // or 'confirm'
    },
    /** 通常メッセージ or 成功メッセージ or エラーメッセージ */
    messageType: {
      type: String,
      default: 'info' // or 'success' or 'error'
    },
    /** ダイアログの見た目 default or classic */
    layoutType: {
      type: String,
      default: 'layout-default'
    },
    /** 通常メッセージ or 成功メッセージ or エラーメッセージ */
    textAlign: {
      type: String,
      default: 'center' // or 'left'
    },
    okBtnLabel: {
      type: String,
      default: 'OK'
    },
    cancelBtnLabel: {
      type: String,
      default: 'キャンセル'
    },
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    /** キャンセル押下時コールバック */
    onCancel: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    }
  },
  computed: {
    titleAreaAddStyle: function () {
      return this.messageType === 'error' ? ' error' : ''
    },
    messageAreaAddStyle: function () {
      return this.textAlign
    }
  },
  data () {
    return {
      modalShown: false,
      saveName: '',
      errors: {}
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onOkLoc: function (event) {
      if (!this.modalShown) return
      if (!this.saveName || this.saveName.length <= 0) {
        this.$set(this.errors, 'saveName', '保存名を入力してください。')
        return
      }
      event.preventDefault()
      this.callbackParams.saveName = this.saveName
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    /** キャンセルボタン押下時 */
    onCancelLoc: function (event) {
      event.preventDefault()
      this.onCancel(this.callbackParams)
      this.modalShown = false
    },
    /** enter|escキー押下時 */
    onKeydown: function (event) {
      if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.keyCode === KEY_CODE.ENTER) {
        this.onOkLoc(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancelLoc(event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#modal {
  z-index: 10000;
}
.left {
  text-align: left;
}
.center {
  text-align: center;
}
.error {
  color: #dc3545;
}
.message-area {
  font-weight: bold;
}
.button-area {
  border-top: none;
}
.modal {
  .modal-main {
    .button-area {
      border-top: none;
    }
  }
}
.error_text {
  line-height: 30px;
  margin-left: 0.5px;
  color: red;
  display: block;
  text-align: center;
  width: 100%;
  font-size: 12px;
}
.name-field {
  width: 28vh;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/SaveModal.vue